export const ETAT_DOCUMENTS_LIST_REQUESTING = 'etat-documents/ETAT_DOCUMENTS_LIST_REQUESTING';
export const ETAT_DOCUMENTS_LIST_SUCCESS = 'etat-documents/ETAT_DOCUMENTS_LIST_SUCCESS';
export const ETAT_DOCUMENTS_LIST_FAILED = 'etat-documents/ETAT_DOCUMENTS_LIST_FAILED';
